import { render, staticRenderFns } from "./ExtruderConfig.vue?vue&type=template&id=41371147&scoped=true"
import script from "./ExtruderConfig.vue?vue&type=script&lang=js"
export * from "./ExtruderConfig.vue?vue&type=script&lang=js"
import style0 from "./ExtruderConfig.vue?vue&type=style&index=0&id=41371147&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41371147",
  null
  
)

export default component.exports